import { useQuery } from '@tanstack/vue-query'
import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import { tradingKeys } from '../tradingQueryKeys'
import { getMyListing } from '../tradingEndpoints'
import { parseMyListingDetail } from '../tradingParser'

// One of the investor's own listings with its fills + history (Listing Details).
export function useMyListingQuery(listingId: MaybeRefOrGetter<string>) {
  return useQuery({
    queryKey: computed(() => tradingKeys.myListing(toValue(listingId))),
    queryFn: () => getMyListing(toValue(listingId)).then(parseMyListingDetail),
    enabled: () => Boolean(toValue(listingId)),
  })
}
